import { render } from "./Payroll.vue?vue&type=template&id=32d5abe8&scoped=true"
import script from "./Payroll.vue?vue&type=script&lang=js"
export * from "./Payroll.vue?vue&type=script&lang=js"

import "./Payroll.vue?vue&type=style&index=0&id=32d5abe8&scoped=true&lang=css"
import "./Payroll.vue?vue&type=style&index=1&id=32d5abe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d5abe8"]])

export default __exports__